import { Component, OnInit } from '@angular/core';
import { User } from '../../model/user';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { Bidding, BiddingStatus, BiddingUpdateAction } from '../../model/bidding';
import { Activity, ActivityStatus, ActivityCategory } from '../../model/activity';
import { DBService } from '../../services/db.service';
import { Company } from '../../model/company';

import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [AuthenticationService, DBService]
})
export class HomeComponent implements OnInit {

  filter: string;
  private sub: any;

  user: User;
  isAdminUser: boolean;

  biddings: Bidding[];
  activities: Activity[];
  companies: Company[];

  opened: boolean;
  month = 'option1';
  loadingBiddings: boolean;
  loadingActivities: boolean;
  loadingCompanies: boolean;

  months: any[];
  private selectedMonth;

  emailsCount: number;
  callsCount: number;
  firstVisitCount: number;
  meetingCount: number;
  proposalCount: number;
  closedClientsCount: number;
  gavelsCount: number;
  habilitationsCount: number;

  pendingParticipationsCount: number;
  participationsCount: number;
  soldAmount: number;
  lostAmount: number;
  totalAmount: number;

  weekAmount: number;
  yearAmount: number;

  totalCount: number;
  earnedCount: number;
  waitingCount: number;
  lostCount: number;

  newClientsCount: number;
  
  reloaded: boolean;

  lineChartData: Array<any>;

  lineChartLabels: Array<any>;
  lineChartOptions: any = { responsive: true };
  lineChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(148,159,177,0.2)',
      borderColor: '#398bf7',
      pointBackgroundColor: '#398bf7',
      pointBorderColor: '#398bf7',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];

  lineChartLegend = false;
  lineChartType = 'line';

  doughnutChartLabels: string[] = ['Perdemos', 'Ganhamos', 'Vendido'];
  doughnutChartData: number[];
  doughnutChartType = 'doughnut';

  recentActivities: RecentActivities[];

  constructor(private authService: AuthenticationService, private router: Router, private dbService: DBService, private route: ActivatedRoute) {

    this.initMonths();
    const user = this.authService.getUser();
    this.user = user;

    if (user == null) {
      this.router.navigate(['/login']);
    } else {
      this.loadingActivities = true;
      this.loadingBiddings = true;
      this.loadingCompanies = true;
      this.initData();
    }
  }

  private initData() {
    this.isAdminUser = this.authService.isAdmin();

    this.dbService.list<Activity>('/activities')
      .then(activities => {
        this.activities = activities;
        this.processActivities();
    });

      this.dbService.listWithUIDs<Company>('/companies')
      .then(companies => {
        this.companies = companies;
        this.processCompanies();

        this.dbService.list<Bidding>('/biddings')
          .then(biddings => {
            this.biddings = biddings;

            if (!this.isAdminUser) {
              this.biddings = this.biddings.filter(b => b.companyUID == this.authService.getUserCompany());
            }

            this.processBiddings();
          });
      });
  }

  private processActivities() {
    const currentYear = new Date().getUTCFullYear();

    const startDate = new Date(currentYear, this.selectedMonth - 1, 1).getTime();
    let finishDate = null;

    if (this.selectedMonth < 12) {
      finishDate = new Date(currentYear, this.selectedMonth, 1).getTime();
    } else {
      finishDate = new Date(currentYear + 1, 1, 1).getTime();
    }

    const partialActivities = this.activities;
      // .filter(a => a.status === ActivityStatus.DONE)
      // .filter(a => a.finishDate >= startDate && a.finishDate < finishDate);

    this.emailsCount = partialActivities.filter(a => a.category == ActivityCategory.EMAIL).length;
    this.callsCount = partialActivities.filter(a => a.category == ActivityCategory.CALL).length;
    this.firstVisitCount = partialActivities.filter(a => a.category == ActivityCategory.VISIT).length;
    this.meetingCount = partialActivities.filter(a => a.category == ActivityCategory.MEETING).length;
    this.proposalCount = partialActivities.filter(a => a.category == ActivityCategory.PROPOSAL).length;
    this.gavelsCount = partialActivities.filter(a => a.category == ActivityCategory.TRADING_FLOOR).length;
    this.habilitationsCount = partialActivities.filter(a => a.category == ActivityCategory.HABILITATION).length;

    this.loadingActivities = false;
  }

  private processBiddings() {
    const currentYear = new Date().getUTCFullYear();

    const startDate = new Date(currentYear, this.selectedMonth - 1, 1).getTime();
    let finishDate = null;

    if (this.selectedMonth < 12) {
      finishDate = new Date(currentYear, this.selectedMonth, 1).getTime();
    } else {
      finishDate = new Date(currentYear + 1, 1, 1).getTime();
    }

    const partialBiddings = this.biddings
      .filter(a => a.biddingDate >= startDate && a.biddingDate < finishDate);

    this.earnedCount = partialBiddings.filter(b => b.status == BiddingStatus.EARNED).length;
    this.waitingCount = partialBiddings.filter(b => b.status == BiddingStatus.ACCEPTED || b.status == BiddingStatus.NEW).length;
    this.lostCount = partialBiddings.filter(b => b.status == BiddingStatus.LOST).length;
    this.totalCount = this.earnedCount + this.waitingCount + this.lostCount;

    this.doughnutChartData = [this.lostCount, this.earnedCount, this.waitingCount];

    this.participationsCount = partialBiddings.filter(b => b.status != BiddingStatus.NEW && b.status != BiddingStatus.REFUSED).length;
    this.pendingParticipationsCount = partialBiddings.filter(b => b.status == BiddingStatus.NEW).length;

    this.soldAmount = partialBiddings
      .filter(b => b.status == BiddingStatus.EARNED)
      .map(b => b.earningPrice)
      .reduce((v1, v2) => v1 + v2, 0);

    this.lostAmount = partialBiddings
      .filter(b => b.status == BiddingStatus.LOST)
      .map(b => b.lostPrice)
      .reduce((v1, v2) => v1 + v2, 0);

    this.totalAmount = this.soldAmount + this.lostAmount;

    this.setYearAmount();
    this.setWeekAmount();

    this.setCashGraphs();

    this.processRecentActivities();

    this.loadingBiddings = false;
  }

  private processRecentActivities() {

    this.recentActivities = [];

    const orderedBiddings = this.biddings.sort((b1, b2) => b2.updatingDate - b1.updatingDate);
    const orderedActivities = this.activities.sort((a1, a2) => a1.creationDate - a2.creationDate);

    for (let i = 1; i <= 20; i++) {
      const recentActivity = new RecentActivities();
      const recentBidingActivity = new RecentActivities();

      if(orderedActivities[i]) {

        const filteredCompanies = this.companies.filter(c => c.uid == orderedActivities[i].companyUID);
        if (filteredCompanies.length == 0) { continue; }
        recentActivity.company = filteredCompanies[0].name;
        recentActivity.date = orderedActivities[i].creationDate;

        recentActivity.text = `Nova atividade registrada.`;
        recentActivity.colorClass = 'green';
        recentActivity.icon = 'check';

        recentActivity.tipo = 'atividades';
        this.recentActivities.push(recentActivity);

      } 
      
      if(orderedBiddings[i]) {      

        const filteredCompanies = this.companies.filter(c => c.uid == orderedBiddings[i].companyUID);
        if (filteredCompanies.length == 0) { continue; }
        recentBidingActivity.company = filteredCompanies[0].name;
        recentBidingActivity.date = orderedBiddings[i].updatingDate;

        if (orderedBiddings[i].updatingAction == BiddingUpdateAction.CREATED) {
          recentBidingActivity.text = `Uma licitação para o órgão ${orderedBiddings[i].purchasingOrgan} foi cadastrada.`;
          recentBidingActivity.colorClass = 'orange';
          recentBidingActivity.icon = 'whatshot';
        } else if (orderedBiddings[i].updatingAction == BiddingUpdateAction.UPDATED) {
          recentBidingActivity.text = `Os dados da licitação para o órgão ${orderedBiddings[i].purchasingOrgan} foram atualizados.`;
          recentBidingActivity.colorClass = 'blue';
          recentBidingActivity.icon = 'edit';
        } else if (orderedBiddings[i].updatingAction == BiddingUpdateAction.ACCEPTED) {
          recentBidingActivity.text = `O cliente aceitou participar da licitação para o órgão ${orderedBiddings[i].purchasingOrgan}.`;
          recentBidingActivity.colorClass = 'green';
          recentBidingActivity.icon = 'check';
        } else if (orderedBiddings[i].updatingAction == BiddingUpdateAction.REFUSED) {
          recentBidingActivity.text = `O cliente se recusou a participar da licitação para o órgão ${orderedBiddings[i].purchasingOrgan}.`;
          recentBidingActivity.colorClass = 'red';
          recentBidingActivity.icon = 'close';
        } else if (orderedBiddings[i].updatingAction == BiddingUpdateAction.EARNED) {
          recentBidingActivity.text = `Aa licitação para o órgão ${orderedBiddings[i].purchasingOrgan} foi vencida.`;
          recentBidingActivity.colorClass = 'green';
          recentBidingActivity.icon = 'gavel';
        } else if (orderedBiddings[i].updatingAction == BiddingUpdateAction.LOST) {
          recentBidingActivity.text = `A licitação para o órgão ${orderedBiddings[i].purchasingOrgan} foi perdida.`;
          recentBidingActivity.colorClass = 'red';
          recentBidingActivity.icon = 'do_not_disturb';
        }
        
        recentBidingActivity.tipo = 'licitacoes';
        this.recentActivities.push(recentBidingActivity);
      }

      this.recentActivities = this.recentActivities.sort((a1, a2) => a2.date - a1.date);
      
    }

  }

  private setCashGraphs() {
    const now = new Date();
    const month = now.getUTCMonth() + 1;

    const data = [];
    this.lineChartLabels = [];

    let currentMonth = 1;

    while (currentMonth++ <= month) {
      let currentDate = new Date(now.getUTCFullYear(), currentMonth - 1, 1).getTime();
      if (currentMonth === 12) {
        currentDate = new Date(now.getUTCFullYear() + 1, 1, 1).getTime();
      }

      const partialAmount = this.biddings
        .filter(a => a.biddingDate < currentDate)
        .filter(b => b.status == BiddingStatus.EARNED)
        .map(b => b.earningPrice)
        .reduce((v1, v2) => v1 + v2, 0);

      data.push(partialAmount);
      this.lineChartLabels.push(this.getSmallMonth(currentMonth - 1));
    }

    this.lineChartData = [ { data: data }];
  }

  private changeMonth() {
    this.loadingCompanies = true;
    this.loadingBiddings = true;
    this.loadingActivities = true;

    this.processActivities();
    this.processBiddings();
    this.processCompanies();
  }

  private setYearAmount() {
    const startDate = new Date(new Date().getUTCFullYear(), 1, 1).getTime();

    this.yearAmount = this.biddings
      .filter(a => a.biddingDate >= startDate)
      .filter(b => b.status == BiddingStatus.EARNED)
      .map(b => b.earningPrice)
      .reduce((v1, v2) => v1 + v2, 0);
  }

  private setWeekAmount() {
    const now = new Date();
    const today = new Date(now.getUTCFullYear(), now.getMonth(), now.getUTCDate());

    const oneDayMS = 24 * 60 * 60 * 1000;

    const startDate = new Date(today.getTime() - oneDayMS * today.getUTCDay()).getTime();

    this.weekAmount = this.biddings
      .filter(a => a.biddingDate >= startDate && a.biddingDate)
      .filter(b => b.status == BiddingStatus.EARNED)
      .map(b => b.earningPrice)
      .reduce((v1, v2) => v1 + v2, 0);
  }

  private processCompanies() {
    const currentYear = new Date().getUTCFullYear();

    const startDate = new Date(currentYear, this.selectedMonth - 1, 1).getTime();
    let finishDate = null;

    if (this.selectedMonth < 12) {
      finishDate = new Date(currentYear, this.selectedMonth, 1).getTime();
    } else {
      finishDate = new Date(currentYear + 1, 1, 1).getTime();
    }

    this.newClientsCount = this.companies.filter(c => c.contractDate >= startDate && c.contractDate < finishDate).length;

    this.loadingCompanies = false;
  }

  ngOnInit() {
  }

  private initMonths() {
    this.months = [];

    const date = new Date();
    const currentMonth = date.getUTCMonth();
    const currentYear = date.getUTCFullYear();

    for(let i = 0; i <= currentMonth; i++) {
      this.months.push(this.getMonthData(i + 1, currentYear));
    }

    this.selectedMonth = currentMonth + 1;
  }

  private getMonthData(month: number, year: number) {
    return { id: month, name: this.getMonth(month) + '/' + year };
  }

  private getMonth(month: number): string {
    let name = '';
    if (month === 1) {
      name = 'Janeiro';
    } else if (month === 2) {
      name = 'Fevereiro';
    } else if (month === 3) {
      name = 'Março';
    } else if (month === 4) {
      name = 'Abril';
    } else if (month === 5) {
      name = 'Maio';
    } else if (month === 6) {
      name = 'Junho';
    } else if (month === 7) {
      name = 'Julho';
    } else if (month === 8) {
      name = 'Agosto';
    } else if (month === 9) {
      name = 'Setembro';
    } else if (month === 10) {
      name = 'Outubro';
    } else if (month === 11) {
      name = 'Novembro';
    } else if (month === 12) {
      name = 'Dezembro';
    }

    return name;
  }

  private getSmallMonth(month: number): string {
    let name = '';
    if (month === 1) {
      name = 'Jan';
    } else if (month === 2) {
      name = 'Fev';
    } else if (month === 3) {
      name = 'Mar';
    } else if (month === 4) {
      name = 'Abr';
    } else if (month === 5) {
      name = 'Mai';
    } else if (month === 6) {
      name = 'Jun';
    } else if (month === 7) {
      name = 'Jul';
    } else if (month === 8) {
      name = 'Ago';
    } else if (month === 9) {
      name = 'Set';
    } else if (month === 10) {
      name = 'Out';
    } else if (month === 11) {
      name = 'Nov';
    } else if (month === 12) {
      name = 'Dez';
    }

    return name;
  }
}

export class RecentActivities {
  company: string;
  text: string;
  date: number;
  link: string;
  colorClass: string;
  icon: string;
  tipo: string;
}


// WEBPACK FOOTER //
// ./src/app/pages/home/home.component.ts